import seoulMetro from '@/assets/imgs/home/mainSlideBanners_v2/서울교통공사.png';
import korail from '@/assets/imgs/home/mainSlideBanners_v2/한국철도공사.png';
import molit from '@/assets/imgs/home/mainSlideBanners_v2/국토교통부.png';
import moleg from '@/assets/imgs/home/mainSlideBanners_v2/법제처.png';
import mois from '@/assets/imgs/home/mainSlideBanners_v2/행안부.png';
import nts from '@/assets/imgs/home/mainSlideBanners_v2/국세청.png';
import fsc from '@/assets/imgs/home/mainSlideBanners_v2/금융위원회.png';
import mofa from '@/assets/imgs/home/mainSlideBanners_v2/외교부.png';
import sr from '@/assets/imgs/home/mainSlideBanners_v2/에스알.png';
import at from '@/assets/imgs/home/mainSlideBanners_v2/한국농수산유통공사.png';
import komsco from '@/assets/imgs/home/mainSlideBanners_v2/한국조폐공사.png';
import kised from '@/assets/imgs/home/mainSlideBanners_v2/창업진흥원.png';
import ncc from '@/assets/imgs/home/mainSlideBanners_v2/국립암센터.png';
import nia from '@/assets/imgs/home/mainSlideBanners_v2/한국지능정보사회진흥원.png';
import nec from '@/assets/imgs/home/mainSlideBanners_v2/중앙선거관리위원회.png';
import mogef from '@/assets/imgs/home/mainSlideBanners_v2/여성가족부.png';
import acrc from '@/assets/imgs/home/mainSlideBanners_v2/국민권익위원회.png';
import kotsa from '@/assets/imgs/home/mainSlideBanners_v2/한국교통안전공단.png';
import chest from '@/assets/imgs/home/mainSlideBanners_v2/사회복지공동모금회_사랑의열매.png';

const LOGOS: { src: string; alt: string }[] = [
  { src: seoulMetro, alt: '서울교통공사' },
  { src: korail, alt: '한국철도공사' },
  { src: molit, alt: '국토교통부' },
  { src: moleg, alt: '법제처' },
  { src: mois, alt: '행정안전부' },
  { src: nts, alt: '국세청' },
  { src: fsc, alt: '금융위원회' },
  { src: mofa, alt: '외교부' },
  { src: sr, alt: 'SR' },
  { src: at, alt: '한국농수산식품유통공사' },
  { src: komsco, alt: '한국조폐공사' },
  { src: kised, alt: '창업진흥원' },
  { src: ncc, alt: '국립암센터' },
  { src: nia, alt: '한국지능정보사회진흥원' },
  { src: nec, alt: '중앙선거관리위원회' },
  { src: mogef, alt: '여성가족부' },
  { src: acrc, alt: '국민권익위원회' },
  { src: kotsa, alt: '한국교통안전공단' },
  { src: chest, alt: '사회복지공동모금회' },
];

/**
 * 도입 기관 로고 마퀴(티커).
 * 숫자 대신 실제 도입 기관 로고로 규모감을 전달한다.
 * 순수 CSS 무한 스크롤 — 배열을 2배 복제해 이음새 없이 흐르게 한다.
 */
export default function LogoWall() {
  const loop = [...LOGOS, ...LOGOS];

  return (
    <section className="pd-section pd-logos">
      <div className="pd-container">
        <div className="pd-head">
          <span className="pd-eyebrow pd-eyebrow--plain">TRUSTED BY</span>
          <h2 className="pd-h2">전국 정부부처·공공기관과 함께합니다</h2>
        </div>
      </div>

      <div className="pd-logos__ticker">
        <div className="pd-logos__track">
          {loop.map((logo, i) => (
            <img key={i} className="pd-logos__logo" src={logo.src} alt={logo.alt} aria-hidden={i >= LOGOS.length} />
          ))}
        </div>
      </div>
    </section>
  );
}
